import { translations } from './translations';
import { LlmGroup, LlmOptions, LlmSlug } from './types';

export const defaultSlug: LlmSlug = {
  llmApp: 'llmApp',
  llmTool: 'llmTool',
  llmAppTool: 'llmAppTool',
  llmThread: 'llmThread',
  llmHistory: 'llmHistory',
  llmFineTuning: 'llmFineTuning',
  llmPrompt: 'llmPrompt',
  llmRule: 'llmRule',
  llmKbAzure: 'llmKbAzure',
  llmKbConfluence: 'llmKbConfluence',
  llmKbDropbox: 'llmKbDropbox',
  llmKbFile: 'llmKbFile',
  llmKbGcs: 'llmKbGcs',
  llmKbGithub: 'llmKbGithub',
  llmKbGoogledrive: 'llmKbGoogledrive',
  llmKbJira: 'llmKbJira',
  llmKbS3: 'llmKbS3',
  llmKbSftp: 'llmKbSftp',
  llmKbSharepoint: 'llmKbSharepoint',
  llmKbSharepointCustom: 'llmKbSharepointCustom',
  llmKbSitemap: 'llmKbSitemap',
  llmKbSlack: 'llmKbSlack',
  llmKbThron: 'llmKbThron',
  llmKbShopify: 'llmKbShopify',
  llmUserUpload: 'llmUserUpload',
  llmVectorDb: 'llmVectorDb',
  llmKbApi: 'llmKbApi',
  llmKbZendesk: 'llmKbZendesk',
};

export const defaultGroup: LlmGroup = {
  llm: 'llm',
};

export const options: LlmOptions = {
  group: defaultGroup,
  slug: defaultSlug,
  translations,
  roles: {
    LlmEditor: 'llm_editor',
    LlmContributor: 'llm_contributor',
  },
};

export const internalSlugs = Object.entries(defaultSlug).map(x => x[1]);
